export default __webpack_public_path__ + "static/media/about.03d22124.svg";